import EfFooterTc from '@elem/ui/ef-footer-tc';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useRouter } from 'next/router';
import { termsMap } from '../../../config/terms';

export default function TheComp() {
    const { locale } = useRouter();
    const termsData = termsMap[locale as keyof typeof termsMap] || termsMap.us;

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfFooterTc list={termsData} />
        </div>
    );
}
